import React from "react";
import { motion } from "framer-motion";
import Loader from "../../../../components/ACS-Dashboard/ACS-Blocks/Loader";

const BulkUploadLoadingModal = ({ onClose }) => {
  return (
    <motion.div
      className="fixed inset-0 z-[1100] bg-black bg-opacity-40 flex items-center justify-center px-fluid-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-fluid-6 space-y-fluid-4 text-center"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        <Loader color="text-custom-bg-blue" message="Uploading contracts and rates..." />

        <p className="text-fluid-sm text-gray-600">
          This might take a few minutes. <br />
          If you close the window, the rates will still be uploaded, but you will
          not see the results of your upload.
        </p>

        <div className="flex justify-center pt-fluid-2">
          <button
            onClick={onClose}
            className="mb-10 px-fluid-button-x py-fluid-button-y border border-gray-300 rounded text-gray-700 hover:bg-gray-100 text-fluid-sm transition"
          >
            Close
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default BulkUploadLoadingModal;
